<template>
    <div>
        <nav aria-label="..." style="margin:0 auto;">
            <ul class="pagination justify-content-center  mt-4">
                <li class="page-item hover mobile-hide" :class="{ disabled: pagination.current_page <= 1 }" :style="{'border-top-left-radius': '20px !important', 'border-bottom-left-radius': '20px !important', 'cursor': 'pointer'}">
                    <a class="page-link" style="cursor: pointer" @click.prevent="changePage(1)" :style="{'border-top-left-radius': '20px !important', 'border-bottom-left-radius': '20px !important', 'cursor': 'pointer'}">First Page</a>
                </li>
                <li class="page-item" :class="{ disabled: pagination.current_page <= 1 }">
                    <a class="page-link" style="cursor: pointer" @click.prevent="changePage(pagination.current_page - 1)">Previous</a>
                </li>


                <li class="page-item" v-for="page in pages"  :key="page" :class="pagination.current_page == page ? 'active' : ''" :style="{'border-top-right-radius': '20px !important', 'border-bottom-right-radius': '20px !important','cursor':'pointer'}" >
                    <a class="page-link" style="cursor: pointer" @click.prevent="changePage(page)">{{ page }}
                        <span v-if="isCurrentPage(page)" class="sr-only">(current)</span>
                    </a>
                </li>


                <li class="page-item" :class="{ disabled: pagination.current_page >= pagination.last_page }">
                    <a class="page-link" style="cursor: pointer" @click.prevent="changePage( (pagination.current_page-0) + (1-0) )">Next</a>
                </li>
                <li class="page-item mobile-hide" :class="{ disabled: pagination.current_page >= pagination.last_page }">
                    <a class="page-link" style="cursor: pointer" @click.prevent="changePage(pagination.last_page)" :style="{'border-top-right-radius': '20px !important', 'border-bottom-right-radius': '20px !important','cursor':'pointer'}" >Last Page</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "PaginationSite",
    props:['pagination', 'offset'],
    mounted() {
        console.log(this.pagination)
    },

    methods: {
        isCurrentPage(page){
            return this.pagination.current_page === page
        },
        changePage(page) {
            if (page > this.pagination.last_page) {
                page = this.pagination.last_page;
            }
            
            this.pagination.current_page = page;
            this.$emit('paginate');
        }
    },
    computed: {
        pages() {
            let pages = []
            let from = this.pagination.current_page - Math.floor(this.offset / 2)
            if (from < 1) {
                from = 1
            }
            let to = from + this.offset -1
            if (to > this.pagination.last_page) {
                to = this.pagination.last_page
            }
            while (from <= to) {
                pages.push(from)
                from++
            }
            return pages
        }
    }

}
</script>
